//prevents default functionality such as anchor navigation onClick
ht.preventDefault = function (e) {
  if (e.preventDefault) {
    e.preventDefault();
  } else {
    //so IE7 will play nice
    e.returnValue = false;
  }
};
